import axios from 'axios'
import router from '@/router/index';
import { ElMessage } from 'element-plus';

// 从 result.data 中提取错误信息
export function getErrorMsg(data) {
	if (typeof data === 'string') return data;
	if (Array.isArray(data) && data.length > 0) return data[0];
	return '';
}
 
// 创建一个 axios 实例
const service = axios.create({
	baseURL: '/api', // 所有的请求地址前缀部分
	timeout: 60000, // 请求超时时间毫秒
	// withCredentials: true, // 异步请求携带cookie
	headers: {
		// 设置后端需要的传参类型
		'Content-Type': 'application/json',
		// 'Authorization': localStorage.getItem('token'),
		'X-Requested-With': 'XMLHttpRequest',
	},
})
 
// 添加请求拦截器
service.interceptors.request.use(
	// config => {
	// 	if (!config.data) {
	// 	  config.data = true // 解决请求没有参数时添加不上Content-Type问题
	// 	}
	// 	// config.headers['Content-type'] = 'application/json;charset=UTF-8'
	// 	return config
	//   },
	//   error => {
	// 	// do something with request error
	// 	return Promise.reject(error)
	//   }

	function (config) {
		if (!config.data) {
		  config.data = true // 解决请求没有参数时添加不上Content-Type问题
		}
		
		// 在发送请求之前做些什么
		const token = localStorage.getItem('token');
		// console.log("token:"+token);
		if (token) {
			config.headers.Authorization = `${token}`;
		}
		return config
	},
	function (error) {
		// 对请求错误做些什么
		console.log(error)
		return Promise.reject(error)
	}
)
 
// 添加响应拦截器
service.interceptors.response.use(
	function (response) {
		if (response.headers.get('X-Token-Expired') === 'true') {
			// 跳登录页，清除本地存储中的 token，登录页则不跳转
			if (response.config.url !== '/login') {
				localStorage.removeItem('token');
				router.push({
					path:'/login'
				});
				// 返回 resolved promise，避免组件捕获到未处理的错误
				// 页面正在跳转，组件会被销毁，返回空数据结构避免组件报错
				return Promise.resolve({ code: 200, data: { records: [], total: 0 } });
			}
		}
		if (response.headers['content-disposition']!==undefined) {
			//导出文件
			// console.log(response.headers['content-disposition'])
			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			// link.download = decodeURIComponent(response.headers['content-disposition'].split("filename*=UTF-8''")[1].replace(/%20/g, '+').replace(/%2A/g, '*').replace(/%25/g, '%')); // 解码文件名
			link.download = decodeURIComponent(response.headers['content-disposition'].split("filename*=UTF-8''")[1])
			// link.download = decodeURIComponent(link.download)
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url); // 释放内存
		}
		// dataAxios 是 axios 返回数据中的 data
		const dataAxios = response.data
		// 这个状态码是和后端约定的
		// console.log(dataAxios)
		const code = dataAxios.reset
		// 非200状态码，自动提示错误信息
		if (dataAxios.code !== undefined && dataAxios.code != 200) {
			const msg = getErrorMsg(dataAxios.data);
			if (msg) {
				ElMessage.error(msg);
			}
		}
		return dataAxios
	},
	function (error) {
		// 超出 2xx 范围的状态码都会触发该函数。
		// 对响应错误做点什么
		// console.log(error.response.data.code)
		// if(error.response && error.response.data){
		// 	if(error.response.data.code==401){
		// 		// 登录失效
		// 		// 清除本地存储中的 token
		// 		localStorage.removeItem('token');
		// 		// 跳转到登录页面
		// 		router.push({
		// 			path:'/login'
		// 		});
		// 	}else if(error.response.data.code==403){
		// 		// 权限不足
		// 		// 清除本地存储中的 token
		// 		localStorage.removeItem('token');
		// 		// 跳转到登录页面
		// 		router.push({
		// 			path:'/login'
		// 		});
		// 	}
		// }
		return Promise.reject(error)
	}
)
 
export default service